import { render, staticRenderFns } from "./DeviceFilesTab.vue?vue&type=template&id=768c10f6&scoped=true"
import script from "./DeviceFilesTab.vue?vue&type=script&lang=js"
export * from "./DeviceFilesTab.vue?vue&type=script&lang=js"
import style0 from "./DeviceFilesTab.vue?vue&type=style&index=0&id=768c10f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768c10f6",
  null
  
)

export default component.exports